module.exports = __webpack_public_path__ + "static/media/sucessAR.43648285.png";